module.exports = __webpack_public_path__ + "bf98526d66c35b7ad4acddd96ac0833f.svg";